// Reorders the checklist after a drag: each visible item travels with the
// hidden items that immediately follow it, so reordering visible items never
// detaches hidden items (e.g. signature questions hidden behind the feature
// flag) from the visible item they belong to. Returns the new items array, or
// null when there is nothing to move (no visible items, or no group at
// `oldIndex`).
export function moveVisibleItemGroups(
  items,
  visibleOriginalIndexes,
  oldIndex,
  newIndex
) {
  const visibleIndexSet = new Set(visibleOriginalIndexes)
  const groupStartIndexes = items.reduce((starts, item, index) => {
    if (visibleIndexSet.has(index)) {
      starts.push(index)
    }

    return starts
  }, [])

  const firstVisibleIndex = groupStartIndexes[0]

  if (firstVisibleIndex === undefined) {
    return null
  }

  if (!Number.isInteger(groupStartIndexes[oldIndex])) {
    return null
  }

  const leadingHidden = items.slice(0, firstVisibleIndex)
  const groups = groupStartIndexes.map((startIndex, position) =>
    items.slice(startIndex, groupStartIndexes[position + 1] ?? items.length)
  )

  const [movedGroup] = groups.splice(oldIndex, 1)
  groups.splice(newIndex, 0, movedGroup)

  return [...leadingHidden, ...groups.flat()]
}
